import styled from 'styled-components';
import { theme } from 'theme';

const MenuButton = styled.button`
  position: relative;

  width: 100%;
  padding: 16px;
  border: 2px solid ${theme.colors.lightBlue};

  text-align: left;
  font-size: 16px;

  background: none;

  :not(:last-child) {
    margin-bottom: 8px;
  }

  i {
    position: absolute;
    right: 0;
    top: 50%;

    transform: translateY(-50%);

    font-size: 32px;
  }
`;

export const Styled = {
  MenuButton,
};
